// @ts-check
'use strict';

/**
 * @higgins/condition-library — condition reporting's shared rules: rating
 * scales, the defect phrase library, report roll-ups and summaries.
 *
 * Used by measure-to-quote's screens (defect chips, pre-filled notes) and by its
 * API (building the Word report), so both always agree. Ported from Site2Scope
 * (Higgins-Coatings/site2scope: conditionLibrary, reportViewModel,
 * summaryLibrary, recommendationLibrary) and generalised from one client's
 * Poor/Fair/Good to any contract's scale. Design:
 * apps/measure-to-quote/docs/CONDITION-REPORTS.md.
 *
 * Plain JavaScript on purpose, like @higgins/sales-risk-rules: an app's api/ is
 * a standalone package compiled by its own tsc and can't compile TypeScript
 * from here.
 */

module.exports = {
  ...require('./scales'),
  ...require('./vocabulary'),
  ...require('./phrases'),
  ...require('./report'),
  ...require('./summaries'),
  ...require('./view-model'),
  ...require('./site-report'),
  ...require('./ids'),
  ...require('./access'),
};
